define('ordersDetailOrderCommentsListCommentTagsView',[
  'module',
  'backbone',
  'underscore',
  'marionette',
  'ordersDetailOrderCommentsListCommentTagView'
], function (
  Module,
  Backbone,
  _,
  Marionette,
  TagView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    childView: TagView,
    className: 'comment-tags-view',

    childEvents: {
      'remove': 'onRemove'
    },

    initialize: function () {
      //console.log('Comment Tags View initialized');
    },

    onRemove: function (model) {
      this.trigger('remove', model);
    }
  });
});
